export default [{
  path: '/authBind/:mediaType',
  name: 'authBind',
  component: () => import('@/pages/authBind/index/index'),
  meta: {
    auth: 'noAuth',
    pageId: 'todo',
    spm: 2270,
  },
},
{
  path: '/authBind/:mediaType/result',
  name: 'authBindResult',
  component: () => import('@/pages/authBind/result/index'),
  meta: {
    auth: 'noAuth',
    pageId: 'todo',
    spm: 2271,
  },
},
{
  path: '/authBind/:mediaType/process',
  name: 'authBindProcess',
  component: () => import('@/pages/authBind/process/index'),
  meta: {
    auth: 'noAuth',
    pageId: 'todo',
    spm: 2272,
  },
},
];
